import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import moment from "moment";
import { encode } from "base-64";

const instance = axios.create();

instance.interceptors.request.use((config) => {
  if (!config?.headers) {
    throw new Error(`Expected 'config' and 'config.headers' not to be undefined`);
  }
  const accessToken = ""; //getUserToken(); TODO
  let correlationAppContext = [
    {
      ApplicationName: "legalsimpli-app",
      CNameOrAzureAppName: window.location.href,
      TimeStamp: moment(),
    },
  ];
  config.headers["correlation-app-context"] = encode(JSON.stringify(correlationAppContext));
  config.headers["Content-Type"] = "application/json";
  if (accessToken) {
    config.headers["Authorization"] = `Bearer ${accessToken}`;
  }
  return config;
});

instance.interceptors.response.use((response) => {
  return response.data;
});

const apiService = {
  get: (url: any, data?: any, headers?: any, withCredentials?: any) => {
    const config = { params: {}, headers: {}, withCredentials: false };
    if (!url) {
      throw Error("endPoint is required params");
    } else {
      if (data) {
        config.params = data;
      }
      if (headers) {
        config.headers = headers;
      }
      if (withCredentials) {
        config.withCredentials = true;
      }
      return instance.get(url, config);
    }
  },
  post: (url: any, data: any, headers?: any) => {
    if (!url || !data) {
      throw Error("endPoint and data are required params");
    }
    return instance.post(url, data, { headers });
  },
  put: (url: any, data: any, headers: any) => {
    if (!url || !data) {
      throw Error("endpoint and data are required params");
    }
    return instance.put(url, data, { headers });
  },
  patch: (url: any, data: any, headers?: any) => {
    if (!url || !data) {
      throw Error("endpoint and data are required params");
    }
    return instance.patch(url, data, { headers });
  },
  delete: (url: any, data: any, headers: any) => {
    if (!url || !data) {
      throw Error("endPoint and data are required params");
    }
    return instance.delete(url, data);
  },
};

export { apiService };
